/**
 * Shared password rules for sign up and change-password.
 * Min 8, max 250, at least one letter and one number.
 */
export const PASSWORD_MIN = 8
export const PASSWORD_MAX = 250

export function isValidPassword(password: string): boolean {
  return (
    password.length >= PASSWORD_MIN &&
    password.length <= PASSWORD_MAX &&
    /[a-zA-Z]/.test(password) &&
    /\d/.test(password)
  )
}
